import { Scope } from '../../../enums/scope'
import { isAuthorized } from '../../../utils/isAuthorized'
import { useIsFrenchUmbrellaOrganization } from './useIsFrenchUmbrellaOrganization'

type FlowOption = 'drawer' | 'default'

export const useFlowOption = (): FlowOption => {
  const isFrenchUmbrellaOrganization = useIsFrenchUmbrellaOrganization()

  if (isFrenchUmbrellaOrganization || isAuthorized(Scope.TransactionRead)) {
    return 'drawer'
  }

  return 'default'
}
